import Vue from 'vue';
import callPhoneNumberVerification from './index.vue';

export default (el) => {
  window.callPhoneNumberVerification = new Vue({
    el,
    data() {
      return {
        successVerificationCallback: () => {}
      };
    },
    render: (h) => h(callPhoneNumberVerification)
  });
};
